module.exports = __webpack_public_path__ + "static/how-to-partner-desktop-933a236cd97fcf5eae2923e1ef357a8b.svg";